import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';

const deepLinkDomains: string[] = [
  new URL(PROJECT_CONFIG.deeplinkHost).host,
  new URL(PROJECT_CONFIG.deeplinkHostNew).host,
];

export function isDeepLink(link: string): boolean {
  try {
    const url = new URL(link);

    // Support for legacy deepLinks
    if (deepLinkDomains.some((host) => url.host === host)) {
      return true;
    }

    const extractedLinkPath = url.pathname.split('/').filter(Boolean)[0];
    const acceptedDeepLinkUrl = new URL(`${ProjectUrls.bffUrl}`);

    return (
      url.host === acceptedDeepLinkUrl.host &&
      extractedLinkPath === PROJECT_CONFIG.deeplinkNativePath
    );
  } catch (error) {
    return false;
  }
}
